import { Icon, ScrollableList } from '@ps/isp-web-component-library';
import React from 'react';

import { useRegulatoryIntl } from '@swf/core/hooks/useRegulatoryIntl';
import { ariaLabelScrollLeft, ariaLabelScrollRight } from '@swf/sports/utils/getAriaLabels';
import { getEventTypeIcon } from '@swf/sports/utils/getEventTypeIcon';

import { useSportsHomePageWidget } from '../../../../model';
import type { InPlayTabWithSlug } from '../../../../model/types';

import styles from './Tabs.scss';

interface Props {
  tabs: InPlayTabWithSlug[];
  selectedTab: InPlayTabWithSlug;
}

const Tabs: React.FC<Props> = ({ tabs, selectedTab }) => {
  const { widgetDispatch } = useSportsHomePageWidget();
  const { formatMessage } = useRegulatoryIntl();

  return (
    <div className={styles.navWrapper}>
      <ScrollableList
        slotProps={{
          previousButton: {
            'aria-label': formatMessage(ariaLabelScrollLeft)
          },
          nextButton: {
            'aria-label': formatMessage(ariaLabelScrollRight)
          }
        }}
      >
        {tabs.map(({ eventTypeName, eventTypeId }) => (
          <ScrollableList.Tab
            key={eventTypeName}
            onClick={() => widgetDispatch.setSelectedInPlayEventType(eventTypeId)}
            active={selectedTab.eventTypeId === eventTypeId}
          >
            <span key={eventTypeName} className={styles.textWrapper}>
              <Icon icon={getEventTypeIcon(eventTypeId)} className={styles.icon} size="x1" />
              {eventTypeName}
            </span>
          </ScrollableList.Tab>
        ))}
      </ScrollableList>
    </div>
  );
};

export default Tabs;
